<script setup lang="ts">
import SectionedVariableProgressBar from 'Common/components/elements/feedback/SectionedVariableProgressBar.vue'
import StatusIndicator from 'Common/components/elements/feedback/StatusIndicator.vue'

interface PropTypes {
  total: number
  requiresInspection: number,
  groundingCondition : number,
  nonGroundingCondition : number,
  forAwareness:number,
  suggestion: number,
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div>
    <div class="font-semibold flex items-center justify-between">
      <span class="text-gray-500 ">Total Discrepancies</span>
      <span class="text-gray-500">{{ props.total }}</span>
    </div>
    <div class="h-5 my-4 sectioned-variable-progress-bar-wrapper">
      <SectionedVariableProgressBar
        :colors="['red-600','je-warning', 'je-intermediate', 'indigo-400', 'je-neutral','je-neutral']"
        bg-color="bg-gray-200"
        :section-counts="[
          props.groundingCondition, 
          props.nonGroundingCondition,
          props.requiresInspection, 
          props.forAwareness, 
          props.suggestion]"
      />
    </div>
    <div>
      <div class="flex px-1 py-2 border-b items-center justify-between">
        <StatusIndicator color="red-600"><span class="text-gray-500">Grounding Discrepancies</span></StatusIndicator>
        <span class="text-sm text-gray-500">{{ props.groundingCondition  }}</span>
      </div>
      <div class="flex px-1 py-2 border-b items-center justify-between">
        <StatusIndicator color="je-warning"><span class="text-gray-500">Non Grounding Discrepancies</span></StatusIndicator>
        <span class="text-sm text-gray-500">{{ props.nonGroundingCondition }}</span>
      </div>
      <div class="flex px-1 py-2  border-b items-center justify-between">
        <StatusIndicator color="je-intermediate"><span class="text-gray-500">Requires Further Inspection</span></StatusIndicator>
        <span class="text-sm text-gray-500">{{ props.requiresInspection}}</span>
      </div>
      <div class="flex px-1 py-2  border-b   items-center justify-between">
        <StatusIndicator color="indigo-400"><span class="text-gray-500">For Awareness</span></StatusIndicator>
        <span class="text-sm text-gray-500">{{ props.forAwareness }}</span>
      </div>
      <div class="flex px-1 py-2  items-center justify-between">
        <StatusIndicator color="je-neutral"><span class="text-gray-500">Suggestion</span></StatusIndicator>
        <span class="text-sm text-gray-500">{{ props.suggestion }}</span>
      </div>
    </div>
  </div>
</template>
